import axios from "axios";
export var fetchPolizaEndorsements = function fetchPolizaEndorsements(poliza_id) {
  return axios.get("/api/v1/poliza_endorsements/", {
    params: {
      poliza_id: poliza_id
    }
  }).then(function (response) {
    return response.data;
  });
};
export var fetchPolizaEndorsement = function fetchPolizaEndorsement(poliza_endorsement_id) {
  return axios.get("/api/v1/poliza_endorsements/".concat({
    poliza_endorsement_id: poliza_endorsement_id
  })).then(function (response) {
    return response.data;
  });
};
export var createJson = function createJson(poliza_endorsement) {
  return fetch("/api/v1/poliza_endorsements", {
    method: "POST",
    headers: {
      Accept: "application/json",
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(poliza_endorsement)
  });
};

var isObject = function isObject(obj) {
  return obj && typeof obj === "object";
};

var isArray = function isArray(obj) {
  return isObject(obj) && obj instanceof Array;
};

var addToFormData = function addToFormData(formData, object_name, object, key) {
  var isInsideCurrentAccount = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  // Check if we're inside current_account by checking the object_name path
  var isCurrentAccount = key === 'current_account' || isInsideCurrentAccount || object_name.includes('[current_account]'); // Handle File objects (for file uploads like endorsement_document)

  if (object[key] instanceof File) {
    formData.append("".concat(object_name, "[").concat(key, "]"), object[key]);
    return;
  }

  if (object[key] == null && !isCurrentAccount) {
    return;
  }

  if (isArray(object[key])) {
    if (["emails", "addresses"].includes(key)) {
      for (var i = 0; i < object[key].length; i++) {
        for (var sub_key in object[key][i]) {
          if (object[key][i][sub_key] !== undefined && object[key][i][sub_key] !== null) {
            formData.append("".concat(object_name, "[").concat(key, "][]").concat(sub_key), object[key][i][sub_key]);
          }
        }
      }
    } else {
      formData.append("".concat(object_name, "[").concat(key, "]"), object[key]);
    }
  } else if (isObject(object[key])) {
    if (object[key] instanceof Date) {
      formData.append("".concat(object_name, "[").concat(key, "]"), object[key]);
    } else {
      // For current_account and its nested properties, send all fields
      for (var subKey in object[key]) {
        var value = object[key][subKey];

        if (isCurrentAccount) {
          // Always send current_account properties, even if null/undefined/empty
          var formValue = value === null || value === undefined ? '' : value;
          formData.append("".concat(object_name, "[").concat(key, "][").concat(subKey, "]"), String(formValue));
        } else {
          // For other nested objects, use the recursive approach
          if (value !== undefined && value !== null) {
            addToFormData(formData, "".concat(object_name, "[").concat(key, "]"), object[key], subKey, false);
          }
        }
      }
    }
  } else {
    formData.append("".concat(object_name, "[").concat(key, "]"), object[key]);
  }
};

var buildPolizaEndorsementFormData = function buildPolizaEndorsementFormData(poliza_endorsement) {
  var removeEndorsementDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var formData = new FormData();

  for (var key in poliza_endorsement) {
    addToFormData(formData, "poliza_endorsement", poliza_endorsement, key);
  } // Add remove_endorsement_document flag if file should be deleted


  if (removeEndorsementDocument) {
    formData.append('poliza_endorsement[remove_endorsement_document]', 'true');
  }

  return formData;
};

export var create = function create(poliza_endorsement) {
  var removeEndorsementDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var formData = buildPolizaEndorsementFormData(poliza_endorsement, removeEndorsementDocument);
  return fetch("/api/v1/poliza_endorsements", {
    method: "POST",
    headers: {
      Accept: "application/json"
    },
    body: formData
  });
};
export var update = function update(poliza_endorsement) {
  var removeEndorsementDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var formData = buildPolizaEndorsementFormData(poliza_endorsement, removeEndorsementDocument);
  return fetch("/api/v1/poliza_endorsements/".concat(poliza_endorsement.id), {
    method: "PUT",
    headers: {
      Accept: "application/json"
    },
    body: formData
  });
};
export var getIndexQueryKey = function getIndexQueryKey(poliza_id) {
  return ["/api/v1/poliza_endorsements/".concat(poliza_id)];
};